import { QcUserSchema } from "@/modules/staff/objects/conversation/QcUser";
import { QcBizLocationGroupSchema } from "./QcBizLocationGroup";
import { SubMenuSchema } from "../guest/SubMenu";
import { MainMenuSchema } from "./MainMenu";
import { z } from "zod";

export type QcBizInquiry = z.infer<typeof QcBizInquirySchema>;
export const QcBizInquirySchema = z.object({
  id: z.number().nullable(),
  guest_id_account: z.number().nullable(),
  main_menu_id: z.number().nullable(),
  sub_menu_id: z.number().nullable(),
  main_menu: MainMenuSchema.nullable(),
  sub_menu: SubMenuSchema.nullable(),
  change_location: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  location_group: QcBizLocationGroupSchema.optional(),
  inquiry_type: z.number().nullable(),
  is_check_out: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  staff_group_names: z
    .array(z.string())
    .nullable()
    .transform((value) => value ?? []),
  staff_qc_user_by_ticket_queue: QcUserSchema.nullable(),
  live_chat_strategy: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
});
